export const LocationUpdateEventType = {
	Transfer: 'Transfer',
} as const;

export type LocationUpdateEventType =
	(typeof LocationUpdateEventType)[keyof typeof LocationUpdateEventType];
